import { useState, useEffect } from 'react'
import { getImageDimensionsFromUrl } from 'utils/file/helpers'
import { bytesToSize } from 'shared'

import styles from './FileInfo.pcss'

interface FileInfoProps {
  file?: File
  fileUrl?: string
  hideSize?: boolean
  hideDimensions?: boolean
  className?: string
  onMetadataLoaded?: (orientation: 'landscape' | 'portrait', width: number, height: number) => void
  onSizeFetched?: (size: number) => void
}

export function FileInfo(props: FileInfoProps) {
  const { onMetadataLoaded, onSizeFetched } = props
  const [fileSize, setFileSize] = useState<number | null>(null)
  const [mediaWidth, setMediaWidth] = useState<number | null>(null)
  const [mediaHeight, setMediaHeight] = useState<number | null>(null)

  useEffect(() => {
    if (props.file) {
      setFileSize(props.file.size)

      const reader = new FileReader()
      reader.onload = () => {
        const img = new Image()
        img.onload = () => {
          setMediaWidth(img.naturalWidth)
          setMediaHeight(img.naturalHeight)
          const orientation = img.naturalWidth > img.naturalHeight ? 'landscape' : 'portrait'
          if (onMetadataLoaded) {
            onMetadataLoaded(orientation, img.naturalWidth, img.naturalHeight)
          }
        }
        img.onerror = (e: any) => {
          console.log('[FileInfo] error loading image: ', e)
        }
        img.src = reader.result as string
      }
      reader.onerror = (e: any) => {
        console.log('[FileInfo] error reading file: ', e)
      }
      reader.readAsDataURL(props.file)
    }
  }, [props.file, onMetadataLoaded])

  useEffect(() => {
    if (props.fileUrl) {
      getImageDimensionsFromUrl(props.fileUrl).then(dimensions => {
        setMediaWidth(dimensions.width)
        setMediaHeight(dimensions.height)
        if (onMetadataLoaded) {
          const orientation = dimensions.width > dimensions.height ? 'landscape' : 'portrait'
          onMetadataLoaded(orientation, dimensions.width, dimensions.height)
        }
      })

      fetch(props.fileUrl, { method: 'head' }).then(res => {
        const size = res.headers.get('content-length')
        if (size) {
          const sizeBytes = parseInt(size, 10)
          setFileSize(sizeBytes)  
          onSizeFetched?.(sizeBytes)  
        }
      })
    }
  }, [props.fileUrl, onMetadataLoaded, onSizeFetched])

  return (
    <div className={`${styles['info-box']} ${props.className || ''}`}>
      {!props.hideSize && Boolean(fileSize) && (
        <span className={styles.bold}>{bytesToSize(fileSize!)}</span>
      )}
      {!props.hideDimensions && mediaWidth && mediaHeight && (
        <span>{`(${mediaWidth}x${mediaHeight})`}</span>
      )}
    </div>
  )
}
